import React from "react";
import "./Ack.css";
import logo from "../logo-vpvv.png";
const Ack = () => {
  return (
    <>
      <div className="ackall">
        <img style={{ padding: "1rem", width: "13rem" }} src={logo} alt="" />
        <div className="ackbox">
          <h2 style={{ color: "white" }}>
            Thank you for completing the form. <br />We look forward to seeing you at
            the event.
          </h2>
        </div>
      </div>
    </>
  );
};

export default Ack;
